:host {
  box-sizing: border-box;
  display: inline-block;
  width: 100%;
}

:host([disabled]) {
  pointer-events: none;
}

cms-button {
  max-width: 1200px;
  display: block;
  margin: 0 auto;
}

button {
  border-radius: css-var(border-radius-0125);
  cursor: pointer;
  display: block;
  font-family: var(--cms-font-trade-gothic);
  font-size: 1rem;
  line-height: 1.5;
  margin: 0 auto;
  margin: css-var(button-default-margin);
  outline: none;
  text-transform: uppercase;
  width: 100%;
  opacity: 1;

  &:disabled {
    opacity: 0.4;
  }

  // Color variations
  &.ghost-dark {
    background-color: transparent;
    @include generateBorder('0125', solid,theme-border-color);

    color: var(--cms-theme-text-color);

    &:hover {
      background-color: rgb(0 0 0 / 5%);
    }

    &:active {
      background-color: rgb(0 0 0 / 40%);
    }
  }

  &.ghost-light {
    background-color: transparent;
    @include generateBorder('0125', solid,white);

    color: var(--cms-white);

    &:hover {
      background-color: rgb(255 255 255 / 20%);
    }

    &:active {
      background-color: rgb(255 255 255 / 40%);
    }
  }

  &.brand-1 {
    background: linear-gradient(
      -180deg,
      var(--cms-brand1-lighter) 0,
      var(--cms-brand1) 20%
    );
    @include generateBorder('0125', solid,brand1-darker);

    color: var(--cms-white);

    &:hover {
      background: var(--cms-brand1);
    }

    &:active {
      background: var(--cms-brand1-darker);
    }
  }

  // Size variations
  &.button-sm {
    min-height: 24px;
    padding: 6px;
  }

  &.button-md {
    min-height: 32px;
    padding: 8px 20px;
  }

  &.button-xl {
    min-height: 36px;
    padding: 12px 20px;
  }
}
